<div class="layout-content-col-inner">
  <div class="layout-middle-col">
    <div *ngIf="loaded">
      <div class="button-action-main">
        <div *ngIf="post.chatid" [routerLink]="['/combined/chat', post.chatid]">
          <mdi name="ChevronLeft"></mdi><span i18n="@@chat">Chat</span>
        </div>
        <div *ngIf="post.groupid" [routerLink]="['/combined/group', post.groupid]">
          <mdi name="ChevronLeft"></mdi><span i18n>Group</span>
        </div>
        <div *ngIf="post.parent && !post.chatid && !post.groupid" [routerLink]="['/combined/clip', post.parent.id]">
          <mdi name="ChevronLeft"></mdi>{{ post.parent.title }}
        </div>
        <div *ngIf="!post.parent && !post.chatid && !post.groupid" [routerLink]="['/combined/timeline']">
          <mdi name="ChevronLeft"></mdi><span i18n>Timeline</span>
        </div>
      </div>
    </div>

    <div>
      <div *ngIf="post?.deleted">
        <h3 i18n>Post has been removed by the owner and is no longer availlable.</h3>
      </div>
      <div *ngIf="loaded && !post?.id">
        <h3 i18n>Post doesn't exists or access denied.</h3>
      </div>
      <div *ngIf="!loaded">
        <app-loading></app-loading>
      </div>

      <div class="parent" *ngIf="post?.id">
        <app-post [clip]="post" updateSource="branch"></app-post>
      </div>

      <div class="clip-replies" *ngIf="replies?.length > 0">
        <h3 i18n>Replies</h3>

        <div class="branch" *ngFor="let clip of replies; let i = index">
          <app-post [clip]="clip" updateSource="branchreply" [updateOrder]="i"></app-post>
        </div>
      </div>
    </div>
  </div>

  <div class="layout-right-col"></div>
</div>
